
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import { Message } from 'element-ui';
import { validateSearchTime } from '@/modules/transport/otp/views/distributeManage/dispatchMgmt/components/util/index.js';

/** 标准化查询数据 */
export const formatSearchData = data => {
    const params = cloneDeep(data);
    const strToArray = str => str ? str.split(',').filter(Boolean) : [];
    const formatTime = (times, key1, key2) => {
        if (times && times.length) {
            const [time1, time2] = times;
            params[key1] = dayjs(time1).format('YYYY-MM-DD HH:mm:ss');
            params[key2] = dayjs(time2).format('YYYY-MM-DD HH:mm:ss');
        } else {
            params[key1] = '';
            params[key2] = '';
        }
    };

    // 服务平台, 司机，承运商，车牌号，客户
    params.siteCodeList = strToArray(params.siteCode);
    params.siteNameList = strToArray(params.siteName);
    params.carrierCodeList = strToArray(params.carrierCode);
    params.carrierNameList = strToArray(params.carrierName);
    params.vehicleCardList = strToArray(params.vehicleCard);
    params.driverList = strToArray(params.driver);
    params.customerCodeList = strToArray(params.customerCode);
    params.customerNameList = strToArray(params.customerName);
    params.warningTypeList = params.warningTypeList || [];
    // 警告时间， 发车时间；
    formatTime(params.firstMonitorTime, 'firstMonitorStartTime', 'firstMonitorEndTime');
    formatTime(params.dispatchTime, 'dispatchStartTime', 'dispatchEndTime');
    formatTime(params.assessWarningTime, 'assessWarningStartTime', 'assessWarningEndTime');
    // 预警状态
    if (params.monitorStatus.length) {
        if (params.monitorStatus.length === 1) {
            params.monitorStatus = params.monitorStatus.join('');
        } else {
            params.monitorStatus = '3';
        }
    } else {
        params.monitorStatus = '';
    }
    delete params.siteName;
    delete params.siteCode;
    delete params.carrierName;
    delete params.carrierCode;
    delete params.vehicleCard;
    delete params.customerCode;
    delete params.customerName;
    delete params.firstMonitorTime;
    delete params.dispatchTime;
    delete params.driverContactWay;
    delete params.driver;
    delete params.assessWarningTime;
    return params;
};

// 校验查询数据
export const validateSearchData = (data) => {
    const isExitTime = (data.dispatchStartTime && data.dispatchEndTime) || (data.firstMonitorStartTime && data.firstMonitorEndTime);
    if (!isExitTime && !data.dispatchNo) {
        Message.warning('发车单号、预警时间、发车时间不可同时为空');
        return false;
    }
    return validateSearchTime(data, 'dispatchStartTime', 'dispatchEndTime', 61) &&
        validateSearchTime(data, 'firstMonitorStartTime', 'firstMonitorEndTime', 61);
};
